var $ = (jQuery = require('jquery'))
angular.module('common.directives').directive('edgeQifi', function () {
  return {
    scope: {
      qrcodeCanvas: '='
    },
    templateUrl: './templates/edge.qifi.view.html?t=' + webpackHash,
    link: function ($scope, $element) {},
    controller: 'edgeQifiController'
  }
})
